/**
 * Pure helpers + shared types for the server-rail drag-and-drop reorder.
 * Extracted from HeroTopBar so the reorder maths is unit-testable in isolation.
 */

export type GuildAvatarDragHandlers = {
  draggable: true;
  onDragStart: (e: React.DragEvent) => void;
  onDragOver: (e: React.DragEvent) => void;
  onDragLeave: () => void;
  onDrop: (e: React.DragEvent) => void;
  onDragEnd: () => void;
};

/**
 * Recompute positions after a drag-drop move in the rail order array.
 * Returns a new array with `draggedId` placed before/after `targetId`.
 */
export function applyRailReorder(
  order: string[],
  draggedId: string,
  targetId: string,
  pos: 'before' | 'after',
): string[] {
  if (draggedId === targetId) return order;
  const without = order.filter((id) => id !== draggedId);
  const ti = without.indexOf(targetId);
  if (ti < 0) return order;
  without.splice(pos === 'before' ? ti : ti + 1, 0, draggedId);
  return without;
}
